import { DropDownItem, GenerateDropDownItems, SearchByItem } from "@app/shared/classes/general";
import { SubRegion } from "@app/shared/classes/subRegion";
import { UserProfileRole } from "@app/shared/classes/user-profile-role";
import { TableColumnDef } from "@app/shared/components/smart-data-grid/data-grid/data-grid.constants";
import { smartSearchType } from "@app/shared/components/smart-search-form/smart-search-form.constant";
import { CommonFieldLabel, CommonFieldName } from "@app/shared/constants";
import { DriverDataBusinessType } from "@app/shared/enums";
import { BusinsessTypesTransform } from "@app/shared/pipes/business-types-transform";
import { CountryCodeTranslate } from "@app/shared/pipes/country-code-translate";
import { LocaleDate } from "@app/shared/pipes/locale-date";
import { BusinessHelper } from "@app/shared/utils/business-helper";
import { SiteConfigHelper } from "@app/shared/utils/site-config.helper";

enum FieldLabel {
  USER_APEX_ID = "ml_144075",
  USER_NAME = "ml_144076",
  ROLE = "ml_144103",
  COUNTRY = "ml_143912",
  SUB_REGION = "ml_143911",
  TERMINAL_NAME = "ml_143910",
  CREATED_BY = "ml_143916",
  CREATED_ON = "ml_143917",

  TERMINAL_ID = "ml_143909",
  TERMINAL = "ml_144113"
}

export enum UserProfileFieldName {
  apexId = "apexId",
  firstName = "firstName",
  lastName = "lastName",
  fullName = "fullName",
  role = "role",
  roleName = "roleName",
  country = "country",
  subRegion_ids = "subRegion_ids",
  terminal_ids = "terminal_ids",
  created_By = "created_By",
  created_On = "created_On",

  terminalId = "terminalId",
  terminalName = "terminalName",
  subRegionName = "subRegionName",
  role_Id = "role_Id"
};

export const DataGridColumnDef: TableColumnDef[] = [
  {
    text: FieldLabel.USER_APEX_ID,
    name: UserProfileFieldName.apexId,
    sort: true
  },
  {
    text: FieldLabel.USER_NAME,
    name: UserProfileFieldName.fullName,
    sort: true,
    sortFieldName: UserProfileFieldName.lastName
  },
  {
    text: FieldLabel.ROLE,
    name: UserProfileFieldName.roleName,
    sort: true
  },
  {
    text: FieldLabel.TERMINAL,
    name: CommonFieldName.terminalId
  },
  {
    text: FieldLabel.SUB_REGION,
    name: UserProfileFieldName.subRegion_ids,
    sort: true
  },
  {
    text: CommonFieldLabel.BUSINESS_TYPE,
    name: CommonFieldName.businessTypes,
    sort: true,
    pipe: BusinsessTypesTransform
  },
  {
    text: FieldLabel.COUNTRY,
    name: UserProfileFieldName.country,
    sort: true,
    pipe: CountryCodeTranslate
  },
  {
    text: FieldLabel.CREATED_BY,
    name: UserProfileFieldName.created_By,
    sort: true
  },
  {
    text: FieldLabel.CREATED_ON,
    name: UserProfileFieldName.created_On,
    sort: true,
    pipe: LocaleDate
  },
]

const UserProfileSearchByList: SearchByItem[] = [
  { searchBy: UserProfileFieldName.apexId, searchByLabel: FieldLabel.USER_APEX_ID },
  { searchBy: UserProfileFieldName.fullName, searchByLabel: FieldLabel.USER_NAME },
  { searchBy: UserProfileFieldName.roleName, searchByLabel: FieldLabel.ROLE, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: UserProfileFieldName.terminalId, searchByLabel: FieldLabel.TERMINAL, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  { searchBy: UserProfileFieldName.subRegionName, searchByLabel: FieldLabel.SUB_REGION, searchByType: smartSearchType.multipleSelect, searchDropDownValue: [] },
  {
    searchBy: CommonFieldName.businessTypes, searchByLabel: CommonFieldLabel.BUSINESS_TYPE, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: BusinessHelper.GetSeperatedBusinessTypeDropDownList()
  },
  {
    searchBy: UserProfileFieldName.country, searchByLabel: FieldLabel.COUNTRY, searchByType: smartSearchType.multipleSelect,
    searchDropDownValue: SiteConfigHelper.GetCountryCodeDropDownList()
  },
];

export const GetUserProfileSearchByList = ([userProfileRoles, terminals, subRegions, isSystemAdmin]: [UserProfileRole[], DropDownItem[], SubRegion[], boolean]) => {
  var result = UserProfileSearchByList.slice();
  result[2].searchDropDownValue = userProfileRoles ? GenerateDropDownItems(userProfileRoles.map(item => item.roleName)) : [];
  result[3].searchDropDownValue = terminals;
  result[4].searchDropDownValue = subRegions ? GenerateDropDownItems(subRegions.map(item => item.subRegionName)) : [];
  if (!isSystemAdmin) {
    return result.slice(0, 4);
  }

  return result;
}
